import _ from "lodash";
import { ROUTE_HOME, ROUTE_TWO_FACTOR_AUTHENTICATION } from "../config/page-routes";

const prepareResponseData = (response) => {
  const unprotectedRoutes = [ROUTE_TWO_FACTOR_AUTHENTICATION, ROUTE_HOME];
  if ((response?.statusCode === 401 || response?.statusCode === 403) && !unprotectedRoutes.includes(window.location.pathname)) {
    window.location = ROUTE_HOME;
  }

  if (
    empty(response) ||
    empty(response.data) ||
    empty(response.data.success) ||
    empty(response.statusText) ||
    response.statusText !== "OK"
  ) {
    return !empty(response.data) && !empty(response.data.message)
      ? {
          ...(isObject(response.data.message)
            ? response.data.message
            : { response: response.data.message }),
          success: false,
          logOut:
            !empty(response.data) && !empty(response.data.message.logOut)
              ? response.data.message.logOut
              : false,
          statusCodeType:
            !empty(response.data) && !empty(response.data.statusCodeType)
              ? response.data.statusCodeType
              : false,
          others: isObject(response.data.message)
            ? (({ logOut, statusCodeType, message, ...rest }) => rest)(
                response.data.message,
              )
            : {},
        }
      : {
          response: "",
          success: true,
          statusCodeType:
            !empty(response.data) && !empty(response.data.statusCodeType)
              ? response.data.statusCodeType
              : false,
        };
  }
  const response_data =
    !empty(response) && !empty(response.data) && !empty(response.data.success)
      ? {
          response: response.data.message,
          success: response.data.success,
          count: !empty(response.data.count) ? response.data.count : 0,
        }
      : { success: response?.data?.success || false };
  return response_data;
};

const isNumber = (value = null) => {
  try {
    return (
      typeof value === "number" &&
      value !== Infinity &&
      value !== -Infinity
    );
  } catch (error) {
    return false;
  }
};

const isBoolean = (value = null) => {
  return typeof value === "boolean" || value === true || value === false;
};

const isUndefined = (value = undefined) => {
  return typeof value === "undefined" || value === undefined;
};

const isObject = (value = null) => {
  return typeof value === "object" &&
    Object.prototype.toString.call(value) === "[object Object]"
    ? true
    : false;
};

const isArray = (value = null) => {
  return (typeof value === "object" &&
    Object.prototype.toString.call(value) === "[object Array]") ||
    Array.isArray(value)
    ? true
    : false;
};

const isString = (value = null) => {
  return typeof value === "string";
};

const isNull = (value = null) => {
  return value === null ? true : false;
};

const empty = (value = null) => {
  let flag = false;
  if (isString(value) && (value === "" || value.trim() === "")) flag = true;
  else if (isNumber(value) && value === 0) flag = true;
  else if (isBoolean(value) && value === false) flag = true;
  else if (isObject(value) && Object.values(value).length === 0) flag = true;
  else if (isArray(value) && value.length === 0) flag = true;
  else if (isUndefined(value)) flag = true;
  else if (isNull(value)) flag = true;
  else if (Array.isArray(value) && value.length === 0) flag = true;
  else if (typeof value === "object" && Object.keys(value).length === 0)
    flag = true;

  return flag;
};

const reIndex = (array, key = "_id") => {
  const indexed_array = {};
  if ((_.isArray(array) || _.isObject(array)) && !_.isEmpty(array)) {
    _.forEach(array, (item) => {
      if (_.isObject(item) && _.has(item, key)) {
        indexed_array[item[key]] = item;
      }
    });
    return indexed_array;
  } else {
    return {};
  }
};

const findGrade = (remarks = [], scoreGrades, defaultCategoryId, score) => {
  let data = [];
  if (empty(remarks)) {
    data =
      !empty(scoreGrades[defaultCategoryId]) &&
      !empty(scoreGrades[defaultCategoryId].remarks)
        ? scoreGrades[defaultCategoryId].remarks
        : [];
  } else if (!empty(remarks) && isArray(remarks)) {
    data = remarks;
  }

  for (const item of data) {
    const _score = isNumber(score) ? Math.ceil(score) : 0;
    if (item.min <= _score && _score <= item.max) {
      return item;
    }
  }

  return {};
};

const compareArrays = (data1, data2) => {
  if (!isArray(data1) || !isArray(data2)) {
    return false;
  }
  if (data1.length !== data2.length) {
    return false;
  }

  for (let i = 0; i < data1.length; i++) {
    const obj1 = data1[i];
    const obj2 = data2[i];

    if (obj1?.name !== obj2?.name || obj1?.title !== obj2?.title) {
      return false;
    }
  }

  return true;
};

const capitalizeFirstChar = (str) => {
  if (!isString(str)) {
    return null;
  }

  let firstChar = str.slice(0, 1);
  if (isString(firstChar)) {
    firstChar = firstChar.toUpperCase();
  }
  const otherChars = str.slice(1);
  return firstChar + otherChars;
}

export {
  capitalizeFirstChar,
  prepareResponseData,
  empty,
  isNumber,
  isArray,
  isBoolean,
  isObject,
  isString,
  isUndefined,
  isNull,
  reIndex,
  findGrade,
  compareArrays
};
